import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(['getmember']),
  },
  methods: {
    delMarkPeriod (GPMId) {
      if (!GPMId) return this.$Message.error('请点选要移除的游戏')
      this.$Modal.confirm({
        title: '提示讯息',
        content: '是否确定删除此期所有设定？',
        onOk: async () => {
          try {
            const res = await this.$axios.gameLobby.delGamePeriodMark({ GPMId: GPMId, loid: this.getmember.pid })
            if (res.status === 1) {
              this.delAction()
              this.$Message.success('刪除成功')
            }
          } catch (error) {
            console.log(error);
          }
        },
        onCancel: () => {

        }
      });
      
    }
  },
}